import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import BoxLayout from "../../../../components/Common/BoxLayout/BoxLayout";
import {
  getCityListActionHandler,
  getCountryListActionHandler,
  getStateListActionHandler,
  getUserGroupsByUserIdActionHandler,
  getUserProfileActionHandler,
} from "../../../../store/actions/actionHandlers/adminActionHandler/userManagementActionHandler";
import { userManagement } from "../../../../utils/mainTabs/admin/userManagement/userManagement";
import { userManagementForm } from "../../../../utils/mainTabs/admin/userManagement/userManagementForm";
import classes from "./UserManagementForm.module.scss";
import Input from "../../../../components/Common/Input/Input";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useSelector } from "react-redux";
import { getMyProfileActionHandler } from "../../../../store/actions/actionHandlers/commonActionHandler";

// export const userMgmgtSchema = yup.object().shape({
//   hybridRadioBtn: yup.string().required(),
// });

const UserManagementForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const params = useParams();
  const { tenantName } = useOutletContext();

  const {
    path: userManageFormPath,
    userDetails,
    userLocation,
    additionalDetails,
    tiles,
    formData,
  } = userManagementForm;

  const userManagementFormPath = userManageFormPath(
    location,
    tenantName,
    params?.userId
  );
  const userManagementPath = userManagement.path(tenantName);
  const addUserPath = userManagement.addUserPath(tenantName);
  const editUserPath = userManagement.editUserPath(tenantName, params?.userId);
  const userDetailsPath = userDetails.path(
    location,
    tenantName,
    params?.userId
  );
  const userLocationPath = userLocation.path(
    location,
    tenantName,
    params?.userId
  );
  const additionalDetailsPath = additionalDetails.path(
    location,
    tenantName,
    params?.userId
  );
  const [flag, setFlag] = useState(false);
  const [heading, setHeading] = useState("");
  const [formValues, setFormValues] = useState(null);
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [storeList, setStoreList] = useState([]);

  useEffect(() => {
    tiles(navigate, location, tenantName, params?.userId).forEach((tile) => {
      if (tile.path === location.pathname) {
        setHeading(tile.label);
      }
    });
  }, [tiles, tenantName, navigate, location, params?.userId]);
  useEffect(() => {
    if (countryList?.length === 0) {
      dispatch(getCountryListActionHandler()).then((countryList) => {
        setCountryList(countryList);
        // setValue("Country", "1433");
      });
    }
  }, [dispatch, countryList?.length]);
  useEffect(() => {
    if (userLocationPath === `${editUserPath}/selectUserLocation`) {
      if (formValues?.Country && stateList?.length === 0)
        dispatch(getStateListActionHandler(formValues?.Country)).then(
          (stateList) => {
            setStateList(stateList);
          }
        );

      if (formValues?.Country && formValues?.State && cityList?.length === 0)
        dispatch(getCityListActionHandler(formValues?.State)).then(
          (cityList) => {
            setCityList(cityList);
          }
        );
    }
  }, [
    dispatch,
    stateList?.length,
    formValues?.Country,
    formValues?.State,
    editUserPath,
    userLocationPath,
    setStateList,
    cityList?.length,
  ]);

  useEffect(() => {
    if (location.pathname === userManagementFormPath) {
      setFlag(true);
      navigate(userDetailsPath);
    } else if (location.pathname.includes(userManagementFormPath) && !flag) {
      navigate(userManagementFormPath);
    }
  }, [
    flag,
    location.pathname,
    navigate,
    userDetailsPath,
    userManagementFormPath,
  ]);
  useEffect(() => {
    if (hybridPath === "aad") {
      dispatch(getMyProfileActionHandler());
    }
  }, [dispatch]);
  const commonState = useSelector((state) => state.commonReducer);
  const { myProfile } = commonState;
  let name = myProfile?.LoginId?.split("@");
  useEffect(() => {
    if (hybridPath === "aad" && myProfile) {
      setFormValues({
        ...formData,
        DomainName: hybridPath === "aad" && [
          { Id: myProfile?.ID, Name: "@" + name?.[1], isVisible: true },
        ],
      });
    }
  }, [myProfile, setFormValues]);

  useEffect(() => {
    if (params?.userId && location.pathname === editUserPath && !formValues) {
      dispatch(getUserProfileActionHandler(params?.userId)).then((data) => {
        dispatch(getUserGroupsByUserIdActionHandler(params?.userId)).then(
          (userGroups) => {
            setFormValues({
              ...data,
              Country:
                data?.Store?.length > 0 ? data?.Store?.[0]?.CountryId : "",
              State: data?.Store?.length > 0 ? data?.Store?.[0]?.StateId : "",
              City: data?.Store?.length > 0 ? data?.Store?.[0]?.CityId : "",
              Store:
                data?.Store?.length > 0
                  ? data?.Store?.map((store) => {
                      return {
                        StoreId: store?.StoreId,
                        StoreName: store?.StoreName,
                      };
                    })
                  : [],
              AssociatedRoles:
                data?.AssociatedRoles?.length > 0
                  ? data?.AssociatedRoles?.map((role) => {
                      return role?.RoleName === "Web Learner" ||
                        role?.RoleName === "Mobile Learner" ||
                        role?.RoleName === "Super Tenant Admin"
                        ? {
                            RoleID: role?.RoleID,
                            RoleName: role?.RoleName,
                            disabled: true,
                          }
                        : {
                            RoleID: role?.RoleID,
                            RoleName: role?.RoleName,
                          };
                    })
                  : [],
              Category:
                data?.Category?.length > 0
                  ? data?.Category?.map((Category) => {
                      return {
                        CategoryId: Category?.CategoryId,
                        Name: Category?.Name,
                      };
                    })
                  : [],
              UserGroupDetails:
                userGroups?.UserGroups?.length > 0
                  ? userGroups?.UserGroups?.map((userGroup) => {
                      return userGroup?.Name === "Default"
                        ? {
                            UserGroupId: userGroup?.UserGroupId,
                            Name: userGroup?.Name,
                            disabled: true,
                          }
                        : {
                            UserGroupId: userGroup?.UserGroupId,
                            Name: userGroup?.Name,
                          };
                    })
                  : [],
            });
          }
        );
      });
    } else if (location.pathname === addUserPath && !formValues) {
      setFormValues(formData);
    }
  }, [
    addUserPath,
    dispatch,
    editUserPath,
    formData,
    formValues,
    location.pathname,
    params?.userId,
    setFormValues,
    location?.pathname,
    formValues,
  ]);
  const methods = useForm({
    mode: "onChange",
    // resolver: yupResolver(userMgmgtSchema),
  });
  const [aadRadio, setAadRadio] = useState(false);
  const [customRadio, setCustomRadio] = useState(false);
  const hybridPath = localStorage.getItem("SecurityProviderName").toLowerCase();
  const tenantData = JSON.parse(localStorage.getItem("tenantData") || "{}");
  const isHybridIdentityTenant =
    tenantData?.SAMLConfig?.IdentityType === 2 &&
    ["saml2", "custom"].includes(hybridPath);
  const addedetailPath = `${userManagementFormPath}/addUserDetails`;
  const aadHandleChange = () => {
    setAadRadio(true);
    setCustomRadio(false);
  };
  const customHandleChange = () => {
    setCustomRadio(true);
    setAadRadio(false);
  };

  return (
    <BoxLayout>
      <div className={classes.userManagementForm}>
        <div className={classes.userManagementForm__heading}>
          <h1>{heading}</h1>
          {isHybridIdentityTenant &&
            location.pathname == addedetailPath &&
            !(location.pathname == `${editUserPath}/addUserDetails`) && (
              <div
                className={classes.userManagementForm__heading__hybridRadioBtns}
              >
                <div
                  className={
                    classes.userManagementForm__heading__hybridRadioBtns__label
                  }
                >
                  Identity <span style={{ color: "red" }}>*</span>
                </div>
                <div
                  className={
                    classes.userManagementForm__heading__hybridRadioBtns__radios
                  }
                >
                  <FormProvider {...methods}>
                    <Input
                      label={"AAD"}
                      name="HybridRadioBtn"
                      type="radio"
                      labelColor="light"
                      direction={"row-reverse"}
                      width="2"
                      height="2"
                      value="aadRadio"
                      onClick={aadHandleChange}
                    />
                    <Input
                      label={"Custom"}
                      name="HybridRadioBtn"
                      type="radio"
                      labelColor="light"
                      direction={"row-reverse"}
                      width="2"
                      height="2"
                      value="customRadio"
                      onClick={customHandleChange}
                    />
                  </FormProvider>
                </div>
              </div>
            )}
        </div>
        <div className={classes.userManagementForm__body}>
          <Outlet
            context={{
              tenantName,
              formValues,
              setFormValues,
              userManagementPath,
              addUserPath,
              editUserPath,
              userDetailsPath,
              userLocationPath,
              additionalDetailsPath,
              countryList,
              setCountryList,
              stateList,
              setStateList,
              cityList,
              setCityList,
              storeList,
              setStoreList,
              aadRadio,
              setAadRadio,
              customRadio,
              setCustomRadio,
            }}
          />
        </div>
      </div>
    </BoxLayout>
  );
};

export default UserManagementForm;
